module.exports = __webpack_public_path__ + "media/clip-intro-daniel.0b2fedb7.mp4";